import { createFileRoute } from '@tanstack/react-router'

import { Authorisation } from '@/lib/auth/components/auth-provider'
import Unauthorized from '@/lib/auth/components/unauthorized'
import { PERMISSIONS } from '@/lib/auth/roles'
import { isCurrentPage, validateSearchWithDefaults } from '@/lib/utils'
import NetworkPerformanceByFirm from '@/modules/network-performance-by-firm'
import { networkPerformanceDataByFirmQueryOptions } from '@/modules/network-performance-by-firm/hooks/hooks'
import {
  mergedNetworkFirmsPerformanceDataSearchSchema,
  NetworkFirmsPerformanceDataSearch,
} from '@/types/route-search-schemas'
import { DataLoader } from '@/types/router-context'
import { NETWORK_FIRMS_PERFORMANCE_PATH } from '@/utils/urls'

export const Route = createFileRoute(NETWORK_FIRMS_PERFORMANCE_PATH)({
  component: NetworkFirmsPerformance,
  validateSearch: (search: Record<string, unknown>): NetworkFirmsPerformanceDataSearch => validateSearchWithDefaults(mergedNetworkFirmsPerformanceDataSearchSchema, search),
  loader: ({ context: { queryClient, date, identity } }: DataLoader) => {
    if (isCurrentPage(NETWORK_FIRMS_PERFORMANCE_PATH)) {
      return
    }

    if (identity?.network && !identity.currentFirm) {
      queryClient.prefetchQuery(networkPerformanceDataByFirmQueryOptions(date))
    }
  },
  beforeLoad: () => {
    return {
      breadcrumbs: [
        { label: 'Firm Performance', path: '#' },
        { label: 'Overview', path: '/' }
      ],
    }
  },
})

function NetworkFirmsPerformance() {
  return (
    <div className='flex flex-col items-center justify-center p-8 sm:p-0'>
      <Authorisation roles={[]} permissions={[PERMISSIONS.IS_NETWORK_VIEW_ON_NETWORK]} forbiddenFallback={<Unauthorized />}>
        <NetworkPerformanceByFirm />
      </Authorisation>
    </div>
  )
}
